/**
 * Root Component List Schema
 *
 * @package lib-components
 * @copyright 2021-2025 Hexio a.s. <contact@hexio.io> (hexio.io) and contributors.
 * @license Apache-2.0
 *
 * See LICENSE file distributed with this source code for more information.
 */

import { RuntimeContext } from "@adapptio/lib-blueprint";
import { IViewParamsSpec } from "@adapptio/lib-shared";
import { ContainerContentSchema } from "../SharedSchemas/Container";

export const RootComponentListSchema = ContainerContentSchema();
export type TRootComponentListSchema = typeof RootComponentListSchema;

/**
 * Type for functions that creates child view
 */
export type TChildViewFactoryFn = (
	viewName: string,
	viewParams: IViewParamsSpec
) => RuntimeContext<TRootComponentListSchema>;
